export default {
  sm: `
  IT 서비스가 새롭게 변화하고 데이터가 끊임
  없이 성장함에 전력 사용도 계속해서 증가할
  것입니다. 데이터센터 각은 다음 세대를 위해
  에너지 소비와 이산화탄소 배출을 줄일 수
  있는 방법에 대해 지속적으로 연구하고
  개발하며, 이를 실천하기 위해 노력하고
  있습니다.
  `,
  md: `
  IT 서비스가 새롭게 변화하고 데이터가 끊임없이 성장함에 전력
  사용도 계속해서 증가할 것입니다. 데이터센터 각은 다음
  세대를 위해 에너지 소비와 이산화탄소 배출을 줄일 수 있는
  방법에 대해 지속적으로 연구하고 개발하며, 이를 실천하기
  위해 노력하고 있습니다.
  `,
  lg: `
  IT 서비스가 새롭게 변화하고 데이터가 끊임없이 성장함에 전력 사용도 계속해서
  증가할 것입니다. 데이터센터 각은 다음 세대를 위해 에너지 소비와 이산화탄소
  배출을 줄일 수 있는 방법에 대해 지속적으로 연구하고 개발하며, 이를 실천하기
  위해 노력하고 있습니다.
  `,
  xxl: `
  IT 서비스가 새롭게 변화하고 데이터가 끊임없이 성장함에 전력 사용도
  계속해서 증가할 것입니다. 데이터센터 각은 다음 세대를 위해 에너지 소비와
  이산화탄소 배출을 줄일 수 있는 방법에 대해 지속적으로 연구하고 개발하며,
  이를 실천하기 위해 노력하고 있습니다.
  `
};
